import { createFeature, createReducer, on } from '@ngrx/store';
import { UserProfileActions } from './user-profile.actions';
import { User } from '../users/users.model';

export const userProfileFeatureKey = 'userProfile';

export interface State {
  loading: boolean,
  user : User,
  error: any
}

export const initialState: State = {
  loading: false,
  user : null,
  error: null
};

export const reducer = createReducer(
  initialState,
  on(UserProfileActions.loadUserProfiles, state => {
    return {
      ...state,
      loading: true
    }
  }),
  on(UserProfileActions.loadUserProfilesSuccess, (state, { data}) => {
    return {
      ...state,
      user: data,
      loading: false
    }
  }),
  on(UserProfileActions.loadUserProfilesFailure, (state, { error }) => {
    return {
      ...state,
      error,
      loading: false
    }
  }),
);

export const userProfileFeature = createFeature({
  name: userProfileFeatureKey,
  reducer,
  extraSelectors: ({ selectUserProfileState }) => {
    return {

    }
  }

});
